/* @ngInject */
const myOwnerEditForm = (
  $$owner
) => {
  return {
    restrict: 'E',
    scope: {
      myOwner: '=',
      enableContacts: '=?',
      enableTitle: '=?',
      enableBack: '=?',
    },
    template: require('./myOwnerEditForm.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.updateOwner = (_owner) => {
        $$owner.ask.update(_owner, true)
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myOwnerEditForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/directives/form/myOwnerEditForm.js